<dx-tab-panel
    class="np-template-product-vertical-tabs h-100"
    [selectedIndex]="0"
    [tabsPosition]="'left'"
    [showNavButtons]="true"
    [scrollByContent]="true"
    [loop]="true"
    (onSelectionChanged)="onTitleClick($event)"
>
  <dxi-item title="{{ 'Produkt' | translate }}">
    <div *dxTemplate>
      <infos/>
    </div>
  </dxi-item>

  <dxi-item title="{{ 'Texte' | translate }}">
    <div *dxTemplate>
      <np-product-texts
          [(model)]="model"
          [(showToolTips)]="showToolTips"
          [(selectedElements)]="selectedElements"
          [templateView]="true"
          [showLinkButtons]="false"
          [isPrint]="modelService?.catalogService?.catalog?.usePrintView"
          [(selectedTranslateLanguage)]="modelService.loginService.selectedTranslateLanguage"
          [(productTranslation)]="modelService.translationService.productTranslation"
          (onValueChanged)="update($event)"
          (elementSelected)="elementSelectFunction($event)"
          [showDragHandle]="showDragHandle"
          [dragFilter]="'> *'"
          (excelElementDropped)="excelElementDrop($event)">
      </np-product-texts>
    </div>
  </dxi-item>

  <dxi-item title="{{ 'Medien' | translate }}" [disabled]="massDataChangeMode">
    <div *dxTemplate>
      <mimes
          [(model)]="model.mimes"
          [(product)]="model"
          [(showToolTips)]="showToolTips"
          [(selectedElements)]="selectedElements"
          [templateView]="true"
          [(exportMode)]="exportMode"
          (onValueChanged)="update($event)"
          (elementSelected)="elementSelectFunction($event)"
          [showDragHandle]="showDragHandle"
          [dragFilter]="'> *'"
          (excelElementDropped)="excelElementDrop($event)"
          (elementDeleted)="elementDelete($event)"
      ></mimes>
    </div>
  </dxi-item>


  <dxi-item title="{{ 'Features' | translate }}">
    <div *dxTemplate>
      <featuresystems
          [featureSystems]="model.featureSystems"
          [templateView]="true"
          [displayMode]="exportMode ? 'export' : 'import'"
          (addEcommerceFeatures)="addEcommerceFeatures()"
          (onValueChanged)="update($event)"
      ></featuresystems>
    </div>
  </dxi-item>

  <dxi-item title="{{ 'Bestelldetails' | translate }}">
    <div *dxTemplate>
      <orderDetail
          [(model)]="model"
          [(showToolTips)]="showToolTips"
          [(selectedElements)]="selectedElements"
          [templateView]="true"
          (onValueChanged)="update($event)"
          [(hasAddonNordwest)]="loginService.hasAddonNordwest"
          [(hasAddonLEGALITY)]="loginService.hasAddonLEGALITY"
          (elementSelected)="elementSelectFunction($event)"
          [showDragHandle]="showDragHandle"
          [dragFilter]="'> *'"
          (excelElementDropped)="excelElementDrop($event)"
      ></orderDetail>
    </div>
  </dxi-item>

  <dxi-item title="{{ 'Preislisten' | translate }}">
    <div *dxTemplate>
      <prices
          [(model)]="model"
          [(showToolTips)]="showToolTips"
          [(selectedElements)]="selectedElements"
          [templateView]="true"
          (onValueChanged)="update($event)"
          [(hasAddonNordwest)]="loginService.hasAddonNordwest"
          [(hasAddonLEGALITY)]="loginService.hasAddonLEGALITY"
          [(priceLists)]="catalogService.catalog.priceLists"
          (elementSelected)="elementSelectFunction($event)"
          [showDragHandle]="showDragHandle"
          [dragFilter]="'> *'"
          (excelElementDropped)="excelElementDrop($event)"
          (elementDeleted)="elementDelete($event)"
      ></prices>
    </div>
  </dxi-item>

  <dxi-item title="{{ 'Logistik' | translate }}">
    <div *dxTemplate>
      <logistic
          [(model)]="model"
          [(showToolTips)]="showToolTips"
          [(selectedElements)]="selectedElements"
          [templateView]="true"
          (onValueChanged)="update($event)"
          (elementSelected)="elementSelectFunction($event)"
          [showDragHandle]="showDragHandle"
          [dragFilter]="'> *'"
          (excelElementDropped)="excelElementDrop($event)"
      ></logistic>
    </div>
  </dxi-item>

  <dxi-item title="{{ 'Referenzen' | translate }}">
    <div *dxTemplate>
      <np-product-references
          [(model)]="model"
          [(showToolTips)]="showToolTips"
          [(lastImageUpload)]="catalogService.catalog.lastImageUpload"
          [(selectedElements)]="selectedElements"
          [templateView]="true"
          (onValueChanged)="update($event)"
          (elementSelected)="elementSelectFunction($event)"
          [showDragHandle]="showDragHandle"
          [dragFilter]="'> *'"
          (excelElementDropped)="excelElementDrop($event)"
          (elementDeleted)="elementDelete($event)"
      ></np-product-references>
    </div>
  </dxi-item>

  <dxi-item title="{{ 'Udx' | translate }}" *ngIf="loginService.hasAddonUDX">
    <div *dxTemplate>
      <udx
          [(model)]="model.udxs"
          [(product)]="model"
          [(showToolTips)]="showToolTips"
          [(selectedElements)]="selectedElements"
          [templateView]="true"
          (onValueChanged)="update($event)"
          (elementSelected)="elementSelectFunction($event)"
          [showDragHandle]="showDragHandle"
          [dragFilter]="'> *'"
          (excelElementDropped)="excelElementDrop($event)"
          (elementDeleted)="elementDelete($event)"
      ></udx>
    </div>
  </dxi-item>

  <dxi-item title="{{ 'Kategorien' | translate }}">
    <div *dxTemplate>
      <app-template-product-categories
          [(model)]="model"
          [(product)]="model"
          [(showToolTips)]="showToolTips"
          [(selectedElements)]="selectedElements"
          [templateView]="true"
          [(exportMode)]="exportMode"
          (onValueChanged)="update($event)"
          (elementSelected)="elementSelectFunction($event)"
          [showDragHandle]="showDragHandle"
          [dragFilter]="'> *'"
          (excelElementDropped)="excelElementDrop($event)"
          (elementDeleted)="elementDelete($event)"
      ></app-template-product-categories>
    </div>
  </dxi-item>

  <dxi-item title="{{ 'ElectronicSales' | translate }}" *ngIf="loginService.hasAddonElectronicSales">
    <div *dxTemplate>
      <electronicSales
          [(model)]="model"
          [(showToolTips)]="showToolTips"
          [(selectedElements)]="selectedElements"
          [templateView]="true"
          (onValueChanged)="update($event)"
          (elementSelected)="elementSelectFunction($event)"
          [showDragHandle]="showDragHandle"
          [dragFilter]="'> *'"
          (excelElementDropped)="excelElementDrop($event)"
      ></electronicSales>
    </div>
  </dxi-item>

  <dxi-item title="{{ 'Wawi' | translate }}" *ngIf="loginService.hasAddonWawiErp">
    <div *dxTemplate>
      <wawi
          [(model)]="model"
          [(selectedElements)]="selectedElements"
          [templateView]="true"
          (onValueChanged)="update($event)"
          (elementSelected)="elementSelectFunction($event)"
          [showDragHandle]="showDragHandle"
          [dragFilter]="'> *'"
          (excelElementDropped)="excelElementDrop($event)"
      ></wawi>
    </div>
  </dxi-item>

  <dxi-item title="{{ 'Recht' | translate }}">
    <div *dxTemplate>
      <productLegal
          [(model)]="model"
          [(showToolTips)]="showToolTips"
          [(warrantyClasses)]="warrantyClassService.warrantyClasses"
          [(hazmatClasses)]="hazmatClassService.hazmatClasses"
          [(selectedElements)]="selectedElements"
          [templateView]="true"
          [massDataChangeMode]="massDataChangeMode"
          [showHTMLSwitch]="false"
          (onValueChanged)="update($event)"
          [(validationService)]="validationService"
          (elementSelected)="elementSelectFunction($event)"
          [showDragHandle]="showDragHandle"
          [dragFilter]="'> *'"
          (excelElementDropped)="excelElementDrop($event)"
      ></productLegal>
    </div>
  </dxi-item>

  <dxi-item title="{{ 'Lieferanten' | translate }}" *ngIf="loginService.hasAddonSUPPLIERS">
    <div *dxTemplate>
      <productSuppliers
          [(product)]="model"
          [(showToolTips)]="showToolTips"
          [(selectedElements)]="selectedElements"
          [templateView]="true"
          [(exportMode)]="exportMode"
          (onValueChanged)="update($event)"
          (elementSelected)="elementSelectFunction($event)"
          [showDragHandle]="showDragHandle"
          [dragFilter]="'> *'"
          (excelElementDropped)="excelElementDrop($event)"
          (elementDeleted)="elementDelete($event)"
      ></productSuppliers>
    </div>
  </dxi-item>

  <dxi-item title="{{ 'Shopware6' | translate }}">
    <div *dxTemplate>
      <np-product-shopware6
          [(model)]="model"
          [(showToolTips)]="showToolTips"
          [(selectedElements)]="selectedElements"
          [templateView]="true"
          [(showProToolTips)]="showProToolTips"
          [(showPlaceHolders)]="showPlaceHolders"
          [showLinkButtons]="true"
          (onValueChanged)="update($event)"
          (elementSelected)="elementSelectFunction($event)"
          [showDragHandle]="showDragHandle"
          [dragFilter]="'> *'"
          (excelElementDropped)="excelElementDrop($event)"
      />
    </div>
  </dxi-item>

  <dxi-item title="{{ 'Sellsite neu' | translate }}" *ngIf="loginService.hasAddonScireum">
    <div *dxTemplate>
      <np-product-scireum
          [(model)]="model"
          [(showToolTips)]="showToolTips"
          [(selectedElements)]="selectedElements"
          [(showProToolTips)]="showProToolTips"
          [templateView]="true"
          [(exportMode)]="exportMode"
          (onValueChanged)="update($event)"
          (elementSelected)="elementSelectFunction($event)"
          [showDragHandle]="showDragHandle"
          [dragFilter]="'> *'"
          (excelElementDropped)="excelElementDrop($event)"
          [excelModel]="excelModel"
      />
    </div>
  </dxi-item>

  <dxi-item title="{{ 'Einstellungen' | translate }}" *ngIf="!massDataChangeMode">
    <div *dxTemplate>
      <misc
          [(model)]="model"
          [(showToolTips)]="showToolTips"
          [(selectedElements)]="selectedElements"
          [(exportMode)]="exportMode"
          (onValueChanged)="update($event)"
          (elementSelected)="elementSelectFunction($event)"
          [showDragHandle]="showDragHandle"
          [dragFilter]="'> *'"
          (excelElementDropped)="excelElementDrop($event)"
          [excelModel]="excelModel"
      ></misc>
    </div>
  </dxi-item>

  <dxi-item title="{{ 'Abverkaufszahlen' | translate }}" *ngIf="!massDataChangeMode && loginService.hasAddonBauvista">
    <div *dxTemplate>
      <np-product-sellthroughfigures
          [model]="model"
          [templateView]="true"
          [(selectedElements)]="selectedElements"
          [showDragHandle]="showDragHandle"
          [dragFilter]="'> *'"
          (elementSelected)="elementSelectFunction($event)"
          (excelElementDropped)="excelElementDrop($event)"
      />
    </div>
  </dxi-item>
</dx-tab-panel>
